module.exports = __webpack_public_path__ + "img/tol.7b543eba.png";